import { vsiGreen, vsiRed } from "./themeStyles";
export const cpuLineColor = '#000000'; //any time you present CPU in a line chart use this color
export const iopsLineColor = '#0066B5'; //any time you present iops in a line chart, use this color
export const latencyLineColor = '#729135'; // any time you present latency in a line chart, use this color

export const latencyLineColorSwap = { // When lots of latency in one chart, these are the options to swap
	read_latency: ['#ffe033', "#cb4634"],
	write_latency: ['#33cccc', "#6F5CFF"],
	avg_latency: ['#fd99ff', '#CE00D1'],
	compressed_latency: [ '#8ed600', '#009900'],
}

export const mbsecLineColor = '#ff8d02'; //any time you are presenting mb/sec in a line chart use this color
export const usedLineColor = '#ff8d02';

export const genericColors = [
	'#ff8d02',
	'#B0EA3B',
	'#099c9d',
	'#CE00D1',
	'#004577',
	'#865aa5',
	'#990000',
	'#0066b5',
	'#999999'
];

export const executiveOverviewColors = [
	'#B0EA3B',
	'#099c9d',
	'#CE00D1',
	'#004577',
	'#865aa5',
	'#990000',
	'#0066b5',
	'#999999'
];

export const databaseTypesColors = [
	"#0f62fe", // IBM DB2 blue
	"#fEb800", // Microsoft SQL Server Database yellow
	"#c74634", // Oracle red
	"#6F5CFF" // MySQL light purple
]

export const weeksLeftColors = ['#0066b5','#e10000', '#F6EE1F', '#8ed600' ]
export const topologyColors = [
	'#990000', //switch
	'#004577', //storage (array)
	latencyLineColor, // host
	'#ff8d02', // zone
]

export const enterpriseTrendColors = [
	'#099c9d',
	'#ff8d02',
	'#865aa5',
	'#B0EA3B',
	'#990000',
	'#999999',
	'#000080' //misc navy blue
];

export const standardCapacityColors = [
	'#ff8d02', //used space orange
	'#8ed600', //capacity green,
	'#099c9d', //free lt blue
	'#865aa5', //orphaned purple
	'#990000', //snap red
	'#000080' //misc navy blue
];

export const entSummaryDeviceCountsColors = [
	'#990000',
	'#CE00D1',
	'#ff8d02',
	'#8ed600',
];


export const provisioningColors = [
	'#ff8d02',  //over-provisioned orange
	'#8ed600',  //Unprovisioned green
	'#865aa5',  //Provisioned Free Purple
	'#F6EE1F', //enterprise needs one more
	'#099c9d'  //Pool Used Teal
];

export const allPerformance = [
	'#0066B5', // iops
	'#729135', // latency
	'#0066B5', //tier 1 iops
	'#729135' // tier 1 latency
];

export const provisioningColorsNoSnap = [
	'#ff8d02',  //over-provisioned orange
	'#8ed600',  //Unprovisioned green
	'#865aa5',  //Provisioned Free Purple
	'#099c9d', //enterprise needs one more
];

export const contiguousFree = ['#729135', '#8ed600'];

export const diskTypeWithFree = [
	'#8ed600',
	'#0C8CFF',
	'#F6EE1F',
	'#000080',
	'#7f33b5',
	'#990000'
];

export const utilizationColors = [
	'#0C8CFF',
	'#865aa5',
	'#B0EA3B'
];

export const heatColors = [
	'#990000',
	'#ff8d02',
	'#FFD700',
	'#bfff00',
	'#8ed600'
]

export const heatColorsSoft = [
	'rgba(153,0,0,0.8)',
	'rgba(255,141,2,0.8)',
	'rgba(255,215,0,0.8)',
	'rgba(191,255,0,0.8)',
	'rgba(142,214,0,0.8)'
]

export	const compressedIopsLatency = [
	iopsLineColor,
	iopsLineColor,
	latencyLineColor,
	'#550000',
	latencyLineColor,
];

export const cpuMbsec = [cpuLineColor, mbsecLineColor];

export const beforeAfterOld = ["#0C8CFF", '#000080', vsiRed];

export const returnPieGridData = (data = [], graphKeys = [], agKey = '') => {
	const numGroupOrder = ['0', '1 - 5', '6 - 10', '11 - 20', '21 - 50', '51 - 200', '> 200', 'Total'];
	const daysGroupOrder = ['< 0', '0 - 13', '14 - 26', '27+', 'Total'];
	const dollarGroupOrder = ['$0 - $100', '$101 - $500', '$501 - $2000', '> $2000'];
	const utilGroupOrder = ['< 10%', '10 - 70%', '71 - 90%', '> 90%']
	
	const numKeys = ['total_vms', 'total_hosts', 'num_vms'];
	const daysKeys = ['days_left_to_capacity'];
	const dollarKeys = ['monthly_total_cost'];
	const utilKeys = ['cpu_util_pct', 'memory_util_pct']

	// Unique graph keys to arrange data
	const uniques = {};
	
	const setUniques = (index, key, metric) => {
		const num = uniques?.[key]?.[metric] || 0;
		const total = uniques?.[key]?.Total || 0;
		
		uniques[key] = {
			...uniques[key],
			[metric]: num + 1,
			Total: total + 1,
		};
	};
	
	data.forEach(datum => {
		graphKeys.forEach((key, gIndex) => {
			let metric = datum[key];
			// days capacity gets integers, and we want to make them more human-readable
			if (daysKeys.includes(key)) {
				if (metric < 0) {
					metric = daysGroupOrder[0];
				} else if (typeof metric === 'number' && metric > 0 && metric <= 13) {
					metric = daysGroupOrder[1];
				} else if (typeof metric === 'number' && metric > 13 && metric <= 26) {
					metric = daysGroupOrder[2];
				} else if (typeof metric === 'number' && metric > 26) {
					metric = daysGroupOrder[3];
				}
			} else if (numKeys.includes(key)) {
				if (metric < 1) {
					metric = numGroupOrder[0];
				} else if (typeof metric === 'number' && metric > 0 && metric < 6) {
					metric = numGroupOrder[1];
				} else if (typeof metric === 'number' && metric >= 6 && metric <= 10) {
					metric = numGroupOrder[2];
				} else if (typeof metric === 'number' && metric > 10 && metric <= 20) {
					metric = numGroupOrder[3];
				} else if (typeof metric === 'number' && metric > 20 && metric <= 50) {
					metric = numGroupOrder[4];
				} else if (typeof metric === 'number' && metric > 50 && metric <= 200) {
					metric = numGroupOrder[5];
				} else if (typeof metric === 'number' && metric > 200) {
					metric = numGroupOrder[5];
				}
			} else if (dollarKeys.includes(key)) {
				if (metric <= 100) {
					metric = dollarGroupOrder[0];
				} else if (typeof metric === 'number' && metric > 100 && metric <= 500) {
					metric = dollarGroupOrder[1];
				} else if (typeof metric === 'number' && metric > 500 && metric <= 2000) {
					metric = dollarGroupOrder[2];
				} else if (typeof metric === 'number' && metric > 2000) {
					metric = dollarGroupOrder[3];
				}
			} else if (utilKeys.includes(key)) {
				if (metric <= 10) {
					metric = utilGroupOrder[0];
				} else if (typeof metric === 'number' && metric > 10 && metric <= 70) {
					metric = utilGroupOrder[1];
				} else if (typeof metric === 'number' && metric > 70 && metric <= 90) {
					metric = utilGroupOrder[2];
				} else if (typeof metric === 'number' && metric > 90) {
					metric = utilGroupOrder[3];
				}
			}
			
			setUniques(gIndex, key, metric);
		});
	});
	
	return graphKeys.map(key => {
		const unique = uniques[key];
		const availableUniques = uniques[key] ? [...Object.keys(uniques[key])] : [];

		if (daysKeys.includes(key)) {
			availableUniques.sort(function(a, b){
				return daysGroupOrder.indexOf(b) - daysGroupOrder.indexOf(a);
			});
		} else if (numKeys.includes(key)) {
			availableUniques.sort(function(a, b){
				return numGroupOrder.indexOf(b) - numGroupOrder.indexOf(a);
			});
		} else if (dollarKeys.includes(key)) {
			availableUniques.sort(function(a, b){
				return dollarGroupOrder.indexOf(b) - dollarGroupOrder.indexOf(a);
			});
		} else if (utilKeys.includes(key)) {
			availableUniques.sort(function(a, b){
				return utilGroupOrder.indexOf(b) - utilGroupOrder.indexOf(a);
			});
		}

		return availableUniques.map(uKey => ({
			name: uKey,
			y: unique[uKey],
		}))
	});
	
}

export const splitPackedBubbleFormatter = (data, grouping, field, grouper) => {
	const grouped = {};

	data.forEach(datum => {
		if (!grouped?.[datum[grouping]]) {
			grouped[datum[grouping]] = [];
		}
		grouped[datum[grouping]].push({
			name: datum[grouper],
			value: datum[field],
		});
	})

	const series = [];
	for (const key in grouped) {
		const config = {
			name: key,
			data: grouped[key],
			animation: false,
			value: parseFloat(grouped[key].reduce((total, num) => total + num.value, 0)).toFixed(2)
		};
		series.push(config);
	}

	return series;
}

export const formatBarData = (data, config = {
	sortingArr: [],
	defs: [],
	sortingField: [],
}) => {

	const { sortingArr, defs, sortingField } = config;
	const newBarData = {
		categories: [],
		series: []
	};
	const seriesDict = {};

	data.forEach(datum => {
		let sortingFieldValue = datum[sortingField]?.toString();
		
		if (!newBarData.categories.includes(sortingFieldValue)) {
			newBarData.categories.push(sortingFieldValue);
		}
		defs.forEach((def, index) => {
			if(!seriesDict[sortingFieldValue?.trim?.()]) {
				seriesDict[sortingFieldValue?.trim?.()] = {};
			}
			if (!seriesDict[sortingFieldValue?.trim?.()][def.field]) {
				seriesDict[sortingFieldValue?.trim?.()][def.field] = 0;
			}
			seriesDict[sortingFieldValue?.trim?.()][def.field] += parseFloat((datum[def.field]));
		})
	});

	defs.forEach(def => {
		const arr = [];
		for(let key in seriesDict) {
			arr.push(seriesDict[key][def.field]);
		}
		newBarData.series.push({
			name: def.headerName,
			data: arr,
		})
	});

	newBarData.series.sort((a, b) => {
		return sortingArr.indexOf(a.name) - sortingArr.indexOf(b.name);
	});

	return newBarData;
};
	
export const forecastColorFormatter = (data, colors) => {
	return colors?.[0] || vsiGreen;
}

export const determineEnvBackground = (num) => {
	let color = 'rgba(0, 123, 255, 0.2)';
	if (num < 90 && num > 69) {
		color = 'rgba(255, 193, 7, 0.2)';
	} else if (num > 90) {
		color = 'rgba(255, 7, 7, 0.2)';
	}
	return color;
}

export const determineEnvBarColor = num => {
	let color = 'rgb(0, 123, 255)';
	if (num < 90 && num > 69) {
		color = ' rgb(255, 193, 7)';
	} else if (num > 90) {
		color = 'rgba(255, 7, 7)';
	}
	return color;
}

export const sortChartDataByValue = (data, order) => {
	// Expecting: {categories: [], series: [{data: []}]}
	let rearranged = [];
	data.categories.forEach((category, i) => {
		rearranged.push({
			name: category,
			value: data.series[0].data[i]
		})
	});

	if (order === 'asc') {
		rearranged.sort(function(a, b) {
			return ((a.value < b.value) ? -1 : ((a.value === b.value) ? 0 : 1));
		});
	} else {
		rearranged.sort(function(a, b) {
			return ((a.value < b.value) ? 1 : ((a.value === b.value) ? 0 : -1));
		});
	}

	rearranged.forEach((datum, i) => {
		data.categories[i] = datum.name;
		data.series[0].data[i] = datum.value
	});
	
	return data;
}